import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
} from 'recharts';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import stylePropType from 'react-style-proptype';
import phrasesPropType from '../proptypes/phrases';
import { Chevron } from './UiIcons';
import { ssColorCyan } from '../constants/style-constants';

const ComparisonBarChartCategory = ({
  data, layers, style, phrases,
}) => {
  const ChartLegend = () => (
    <>
      <span className="comparison-bar-chart-category__legend--self">
        {data[layers[0].dataKey] > 0 ? `${data[layers[0].dataKey]}%` : ''}
      </span>
      <span className="comparison-bar-chart-category__legend--other">
        {data[layers[1].dataKey] > 0 ? `${data[layers[1].dataKey]}%` : ''}
      </span>
    </>
  );

  return (
    <div className="row comparison-bar-chart-category" style={style}>
      <div className="col-5 col-lg-5 comparison-bar-chart-category__category">
        <div className="comparison-bar-chart-category__category__name">{data.attributeName}</div>
        {data.link && (
          <a className="comparison-bar-chart-category__category__learn_more" href={data.link}>
            Learn More
          </a>
        )}
      </div>
      <div className="col-5 col-lg-5 comparison-bar-chart-category__graph">
        {!data.ranking && (<span className="comparison-bar-chart-category__no_data comparison-bar-chart-category__no_data--ranking">{phrases.noData}</span>)}
        {!data.averageRanking && (<span className="comparison-bar-chart-category__no_data comparison-bar-chart-category__no_data--averageRanking">{phrases.noData}</span>)}
        <ResponsiveContainer width="100%" height={45}>
          <BarChart
            data={[data]}
            layout="vertical"
            barSize={16}
            barGap={6}
            margin={{
              top: 0, left: 0, right: 0, bottom: 0,
            }}
          >
            <XAxis hide type="number" domain={[0, 100]} />
            <YAxis hide type="category" />
            {map(layers, layer => (
              <Bar key={layer.dataKey} dataKey={layer.dataKey} fill={layer.fill} />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
      {data.link ? (
        <a className="col-2 comparison-bar-chart-category__legend" href={data.link}>
          <ChartLegend />
          <Chevron width={18} height={30} color={ssColorCyan} />
        </a>
      ) : (
        <div className="col-2 comparison-bar-chart-category__legend">
          <ChartLegend />
        </div>
      )}
    </div>
  );
};

ComparisonBarChartCategory.propTypes = {
  data: PropTypes.shape({
    ranking: PropTypes.number,
    averageRanking: PropTypes.number,
    attributeName: PropTypes.string.isRequired,
    link: PropTypes.string,
  }).isRequired,
  layers: PropTypes.arrayOf(PropTypes.object).isRequired,
  style: stylePropType.isRequired,
  phrases: phrasesPropType.isRequired,
};

export default ComparisonBarChartCategory;
